import React from 'react'

function IrpObjectives() {
  return (
    <div>
        <ul className='list-disc list-inside'>
            <li>To provide self-employed or employees in organizations that do not operate occupational pension scheme, with an opportunity to save regularly for a reliable and long-term retirement</li>
            <li>To enable self-employed or employees in organizations that do not operate occupational pension scheme to take advantage of the generous income tax relief available to members of a registered retirement</li>
            <li>To enable an employer with few employees (below 10) set up a pension fund for them</li>
            <li>To enable a withdrawing member of an employer retirement benefits scheme, preserve their accumulated retirement fund in whole or the 100% deferred employer benefit until they reach retirement</li>
        </ul>



    </div>
  )
}

export default IrpObjectives